import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
    selector: 'pax-secondary-button',
    standalone: true,
    imports: [LucideAngularModule, NgClass],
    styleUrls: ['./secondary-button.component.scss'],
    template: `
        <button
            type="button"
            [disabled]="disabled()"
            [attr.aria-disabled]="disabled()"
            [attr.aria-label]="disabled() ? 'Button is disabled' : ''"
            class="flex gap-2 items-center px-6 py-3 rounded-[24px] transition-colors border"
            [ngClass]="{
                'bg-[var(--pax-secondary-button-background)] border-[var(--pax-secondary-button-border-color)] hover:bg-[var(--pax-secondary-button-background-hover)] text-[var(--pax-secondary-button-text-color)]':
                    !disabled(),
                'border-[var(--pax-secondary-button-border-color-disabled)] text-[var(--pax-secondary-button-text-color-disabled)] cursor-not-allowed': disabled(),
            }"
        >
            @if (iconPosition() === 'left' && iconName()) {
                <lucide-icon [name]="iconName()" size="24"></lucide-icon>
            }

            <ng-content></ng-content>

            @if (iconPosition() === 'right' && iconName()) {
                <lucide-icon [name]="iconName()" size="24"></lucide-icon>
            }
        </button>
    `,
})
export class SecondaryButtonComponent {
    readonly iconName = input<string>();
    readonly iconPosition = input<'left' | 'right'>('right');
    readonly disabled = input<boolean>(false);
}
